import { changeControlEn } from './change-control-en';

export const changeControlFr = {
  ...changeControlEn,
  title: 'Gestion des modifications',
  subtitle:
    'Évaluer les impacts intermodules, coordonner les revues et créer des révisions contrôlées.',
  help: 'Ouvrir l’aide sur la gestion des modifications',
  tabs: { requests: 'Demandes de modification', customerApprovals: 'Approbations client' },
  actions: {
    new: 'Nouvelle demande',
    analyze: 'Analyser les impacts',
    submit: 'Soumettre',
    reviewed: 'Terminer la revue',
    'changes-requested': 'Demander des corrections',
    approve: 'Approuver',
    reject: 'Rejeter',
    'start-implementation': 'Démarrer la mise en œuvre',
    complete: 'Terminer la mise en œuvre',
    cancel: 'Annuler la demande',
    archive: 'Archiver',
  },
  filters: {
    search: 'Rechercher numéro, titre, source ou article',
    allStatuses: 'Tous les statuts',
    allRisks: 'Tous les niveaux de risque',
    allSources: 'Tous les types de source',
  },
  columns: {
    number: 'Numéro',
    title: 'Titre',
    source: 'Source',
    status: 'Statut',
    risk: 'Risque',
    responsible: 'Responsable',
    impact: 'Objets affectés',
    updated: 'Modifié',
    actions: 'Actions',
  },
  statuses: {
    DRAFT: 'Brouillon',
    IN_REVIEW: 'En revue',
    CHANGES_REQUESTED: 'Corrections requises',
    REVIEWED: 'Revu',
    APPROVED: 'Approuvé',
    IMPLEMENTING: 'En mise en œuvre',
    IMPLEMENTED: 'Mis en œuvre',
    REJECTED: 'Rejeté',
    CANCELLED: 'Annulé',
    ARCHIVED: 'Archivé',
  },
  risks: { LOW: 'Faible', MEDIUM: 'Moyen', HIGH: 'Élevé', CRITICAL: 'Critique' },
  sourceTypes: {
    PRODUCT: 'Article / matière',
    MATERIAL_PROFILE: 'Profil matière',
    SUPPLIER_SPECIFICATION: 'Spécification fournisseur',
    RECIPE: 'Recette / nomenclature',
    DECLARATION: 'Déclaration',
    ANALYSIS_PROFILE: 'Analyse / nutrition',
    PROCESS_ROUTING: 'Gamme de processus',
    PACKAGING: 'Emballage',
  },
  assigneeRoles: {
    RESPONSIBLE: 'Responsable',
    REVIEWER: 'Réviseur',
    APPROVER: 'Approbateur',
    OBSERVER: 'Observateur',
  },
  taskStatuses: {
    OPEN: 'Ouverte',
    IN_PROGRESS: 'En cours',
    COMPLETED: 'Terminée',
    CANCELLED: 'Annulée',
  },
  decisions: {
    SUBMITTED: 'Soumise',
    REVIEWED: 'Revue',
    CHANGES_REQUESTED: 'Corrections demandées',
    APPROVED: 'Approuvée',
    REJECTED: 'Rejetée',
    IMPLEMENTING: 'Mise en œuvre démarrée',
    IMPLEMENTED: 'Mise en œuvre terminée',
    CANCELLED: 'Annulée',
    ARCHIVED: 'Archivée',
  },
  nodeTypes: {
    SOURCE: 'Source de modification',
    RECIPE: 'Recettes / nomenclatures',
    PRODUCT: 'Produits',
    PRODUCTION_ORDER: 'Ordres de fabrication',
    PRODUCTION_PLAN: 'Planification de production',
    DECLARATION: 'Déclarations',
    SPECIFICATION: 'Spécifications produit',
    LABEL_TEMPLATE: 'Modèles d’étiquette',
    CUSTOMER_APPROVAL: 'Approbations client',
    SALES_ORDER: 'Commandes client ouvertes',
    PROCESS_ROUTING: 'Gammes de processus',
    ANALYSIS_PROFILE: 'Profils d’analyse',
    PACKAGING: 'Emballages',
  },
  draftTargetTypes: {
    RECIPE: 'Recette / nomenclature',
    PROCESS_ROUTING: 'Gamme de processus',
    DECLARATION: 'Déclaration',
    ANALYSIS_PROFILE: 'Profil d’analyse',
    SPECIFICATION: 'Spécification produit',
    LABEL_TEMPLATE: 'Modèle d’étiquette',
  },
  draftStatuses: {
    PROCESSING: 'Création en cours',
    CREATED: 'Révision créée',
    FAILED: 'Échec de création',
  },
  form: {
    newTitle: 'Créer une demande de modification',
    newDescription:
      'Saisir la source, l’état cible, le risque et les responsabilités indépendantes.',
    editTitle: 'Modifier la demande',
    editDescription: 'Seuls les brouillons et les demandes retournées sont modifiables.',
    title: 'Titre',
    reason: 'Motif',
    sourceType: 'Type de source',
    source: 'Objet source',
    sourceVersion: 'Version source',
    sourceSearch: 'Rechercher la source',
    sourceSearchPlaceholder: 'Numéro, nom, fournisseur ou domaine',
    selectSource: 'Sélectionner une source contrôlée',
    noSources: 'Aucune source correspondante.',
    noVersion: 'Données de base sans version distincte',
    sourceIdPlaceholder: 'ID de l’objet source',
    optionalId: 'ID de version facultatif',
    selectProduct: 'Sélectionner un article',
    risk: 'Niveau de risque',
    riskAssessment: 'Évaluation du risque',
    before: 'Avant',
    after: 'Après',
    requestedEffectiveDate: 'Date d’effet souhaitée',
    effectiveDate: 'Date d’effet',
    dueDate: 'Échéance',
    responsibleId: 'Responsable',
    reviewerId: 'Réviseur',
    approverId: 'Approbateur',
    selectUser: 'Sélectionner un utilisateur',
    note: 'Note motivée',
  },
  messages: {
    invalidJson: 'Les valeurs avant et après doivent être des objets JSON valides.',
    invalidForm: 'Veuillez renseigner tous les champs obligatoires avec des valeurs valides.',
    noteRequired: 'Saisissez une note motivée d’au moins trois caractères.',
    created: 'La demande {{number}} a été créée.',
    saved: 'Modifications enregistrées.',
    analyzed: 'Analyse d’impact enregistrée.',
    notFound: 'La demande de modification est introuvable.',
    workflow: {
      submit: 'Soumise pour revue.',
      reviewed: 'Revue terminée.',
      'changes-requested': 'Corrections demandées.',
      approve: 'Demande approuvée.',
      reject: 'Demande rejetée.',
      'start-implementation': 'Mise en œuvre démarrée.',
      complete: 'Mise en œuvre terminée.',
      cancel: 'Demande annulée.',
      archive: 'Demande archivée.',
    },
  },
  sections: {
    overview: 'Vue d’ensemble',
    request: 'Demande et risque',
    assignees: 'Responsabilités',
    diff: 'Avant / après',
    impact: 'Graphe d’impact',
    tasks: 'Tâches',
    drafts: 'Révisions contrôlées',
    documents: 'Documents',
    audit: 'Historique de revue et d’audit',
  },
  diff: {
    beforeDescription: 'État initial immuable enregistré avec la demande.',
    afterDescription: 'État cible à revoir et à approuver.',
  },
  impact: {
    warnings: 'Avertissements de l’analyse d’impact',
    relations: 'Relations',
    noRelations: 'Aucune relation identifiée.',
    openNode: 'Ouvrir {{label}}',
    requiredTitle: 'Analyse d’impact actuelle requise',
    requiredDescription: 'Analysez et enregistrez tous les objets affectés avant de soumettre.',
    notAnalyzed: 'Aucune analyse d’impact actuelle.',
    version: 'Instantané d’impact v{{version}}, créé le {{date}}',
  },
  impactWarnings: {
    SUPPLIER_SOURCE_NOT_VERSIONED:
      'Les informations fournisseur n’ont pas de version distincte; le dossier fige les valeurs avant/après.',
    PACKAGING_SOURCE_NOT_VERSIONED:
      'Les données d’emballage n’ont pas de version distincte; le dossier fige les valeurs avant/après.',
    BOM_TRAVERSAL_DEPTH_REACHED:
      'Le parcours de nomenclature a atteint la profondeur maximale de 50.',
    NO_DEPENDENCIES: 'Aucun objet dépendant trouvé pour cette source.',
  },
  tasks: {
    new: 'Ajouter une tâche',
    description: 'Attribuer une activité concrète, un responsable et une échéance.',
    created: 'Tâche créée.',
    completedInUi: 'Terminée dans le flux de modification.',
    complete: 'Terminer',
    reopen: 'Rouvrir',
    columns: { status: 'Statut', task: 'Tâche', assignee: 'Assigné à', due: 'Échéance' },
    form: { description: 'Description' },
  },
  drafts: {
    title: 'Les versions publiées restent inchangées',
    description:
      'Créez un nouveau brouillon ou une révision contrôlée pour chaque version approuvée affectée. Aucun document publié n’est écrasé.',
    pending: 'Aucune révision créée',
    create: 'Créer la révision',
    created: 'Un brouillon ou une révision contrôlée a été créé.',
  },
  workflow: {
    submit: {
      title: 'Soumettre la demande',
      description: 'L’instantané d’impact est figé pour la revue indépendante.',
    },
    reviewed: {
      title: 'Terminer la revue',
      description: 'Confirmer la vérification des impacts, du risque et de l’état cible.',
    },
    'changes-requested': {
      title: 'Demander des corrections',
      description: 'Décrire précisément les corrections requises.',
    },
    approve: {
      title: 'Approuver la demande',
      description: 'Définir la date d’effet et fournir une note d’approbation indépendante.',
    },
    reject: {
      title: 'Rejeter la demande',
      description: 'Indiquer pourquoi la demande ne doit pas être mise en œuvre.',
    },
    'start-implementation': {
      title: 'Démarrer la mise en œuvre',
      description: 'Les tâches et révisions contrôlées peuvent maintenant être réalisées.',
    },
    complete: {
      title: 'Terminer la mise en œuvre',
      description: 'Toutes les tâches et révisions requises doivent être terminées.',
    },
    cancel: {
      title: 'Annuler la demande',
      description: 'L’annulation est auditée sans modifier les documents publiés.',
    },
    archive: {
      title: 'Archiver la demande',
      description: 'Le dossier terminé et ses preuves restent immuables.',
    },
  },
  empty: {
    requests: 'Aucune demande ne correspond aux filtres.',
    approvals: 'Aucune approbation client.',
    tasks: 'Aucune tâche ajoutée.',
    drafts: 'Aucune version approuvée de cet impact ne nécessite une révision.',
    audit: 'Aucune décision de workflow enregistrée.',
  },
  taskCount: '{{count}} tâche(s) ouverte(s)',
  pagination: 'Page {{page}} sur {{pages}} · {{total}} demandes',
  customer: {
    actions: { new: 'Nouvelle approbation client', approve: 'Approuver', revoke: 'Révoquer' },
    columns: {
      reference: 'Référence',
      customer: 'Client',
      product: 'Article',
      scope: 'Périmètre',
      validity: 'Validité',
    },
    statuses: {
      DRAFT: 'Brouillon',
      APPROVED: 'Approuvée',
      EXPIRED: 'Expirée',
      REVOKED: 'Révoquée',
    },
    form: {
      title: 'Enregistrer une approbation client',
      description:
        'Les données approuvées sont stockées dans un instantané protégé par hachage et nécessitent une approbation indépendante.',
      selectCustomer: 'Sélectionner un client',
      snapshot: 'Instantané des données approuvées (JSON)',
      validFrom: 'Valide à partir du',
      validTo: 'Valide jusqu’au',
    },
    dialog: {
      approve: 'Approuver l’approbation client',
      revoke: 'Révoquer l’approbation client',
      description: 'La décision et son motif sont consignés dans la piste d’audit.',
    },
    messages: {
      created: 'Approbation client créée.',
      approved: 'Approbation client approuvée.',
      revoked: 'Approbation client révoquée.',
    },
  },
} as const;
